export enum CylinderType {
  cylinder30 = '30 kg',
  cylinder20 = '20 kg',
  all = 'all',
}
